import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Button from "../Buttons/Button";
import { useTranslationApp } from "../../lib/i18next";
import { useSelectorApp } from "../../lib/redux";
import useWhiteLabelPurchase from "../../hooks/useWhiteLabelPurchase";
import {
  WHITE_LABEL_ALREADY_ACTIVE,
  WHITE_LABEL_BUY,
  WHITE_LABEL_ONLY_OWNER,
} from "../../i18n/keysTranslations";
import { getWhiteLabelPricingBenefit } from "../../utils/whiteLabelAddon";

/**
 * Signed-in action next to the agency plan's white-label benefit.
 * Logged-out visitors keep the benefit text with no price and no button.
 */
const WhiteLabelPricingBenefitAction = () => {
  const { t } = useTranslationApp();
  const authUserID = useSelectorApp((state) => state.auth.user?.uid);
  const purchase = useWhiteLabelPurchase();
  const kind = getWhiteLabelPricingBenefit({
    isSignedIn: Boolean(authUserID),
    whiteLabel: purchase.whiteLabel,
  });

  if (kind === "hidden") return null;

  if (kind === "alreadyActive") {
    return (
      <Typography
        component="span"
        variant="caption"
        sx={{ fontWeight: 600, color: "#1B7F4E", whiteSpace: "nowrap" }}
      >
        {t(WHITE_LABEL_ALREADY_ACTIVE)}
      </Typography>
    );
  }

  return (
    <>
      {purchase.canManage ? (
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={purchase.startCheckout}
          sx={{
            fontSize: "13px",
            fontWeight: 600,
            whiteSpace: "nowrap",
            verticalAlign: "baseline",
          }}
        >
          {t(WHITE_LABEL_BUY)}
        </Link>
      ) : (
        <Button
          color="secondary"
          disabled
          tooltip={t(WHITE_LABEL_ONLY_OWNER)}
          sx={{ minWidth: 0, px: 1.5, py: 0.5 }}
        >
          {t(WHITE_LABEL_BUY)}
        </Button>
      )}
    </>
  );
};

export default WhiteLabelPricingBenefitAction;
